import React from 'react';
import PropTypes from 'prop-types';
import {
  FileDropzone,
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
  textareaTheme,
} from '../../../lib';


const formName = 'Seals';

const defaultValues = {
  'Quantity': '',
  'Graphics': '',
  'Corporate-or-logo': '',
  'Size': '',
  'Style': '',
};

const fields = [
  'Quantity',
  'Graphics',
  'Corporate-or-logo',
  'Size',
  'Style',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <Radio
        radioId='Graphics'
        radioName='Graphics'
        legend='Graphics?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Corporate-or-logo'
        radioName='Corporate-or-logo'
        legend='Corporate or Logo?'
        options={[
          { value: 'corporate', label: 'Corporate' },
          { value: 'logo', label: 'Logo' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Size'
        radioName='Size'
        legend='Size'
        options={[
          { value: '1-5/8', label: 'Standard 1 5/8" diameter' },
          { value: '2', label: '2" diameter' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Style'
        radioName='Style'
        legend='Style'
        options={[
          { value: 'metal', label: 'Metal embossing seal' },
          { value: 'self-inking', label: 'Self-inking seal' },
          { value: 'tradtional', label: 'Traditional rubber seal' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />

    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
